import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import styles from '../styles/NotFound.module.scss';
import LightRays from '../components/LightRays/LightRays';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>ФА | Страница не найдена</title>
      </Helmet>

      <div className={styles.notFound}>
        <div className={styles.raysBackground}>
          <LightRays
            raysOrigin='top-center'
            raysColor='#ffffff'
            raysSpeed={1}
            lightSpread={1}
            rayLength={3}
            followMouse={true}
            mouseInfluence={0.1}
            noiseAmount={0.5}
            distortion={0}
            className='custom-rays'
            pulsating={false}
            fadeDistance={1}
            saturation={1}
          />
        </div>

        {/* Контент поверх лучей */}
        <div className={styles.content}>
          <h1 className={styles.errorCode}>404</h1>
          <h2 className={styles.title}>Страница не найдена</h2>
          <p className={styles.subtitle}>
            Кажется, вы забрели не туда. Этот путь ведет в никуда, но выглядит
            здесь красиво.
          </p>

          <Link to='/' className={styles.homeButton}>
            Вернуться на главную
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
